import { isAbortError } from '@reatom/framework';
import { isApiCancel } from '@/js/libs/api/index.ts';
import { UNMOUNT } from './constants.js';
const isCancelError = (error) => error === UNMOUNT || isApiCancel(error) || isAbortError(error);
export default isCancelError;
